import { render, staticRenderFns } from "./GreyQorayLogo.vue?vue&type=template&id=28642d82"
import script from "./GreyQorayLogo.vue?vue&type=script&lang=js"
export * from "./GreyQorayLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports